/**
 * mapping.js에 추가할 토큰 갱신 관리자
 * 중복 refresh 요청을 방지하고 대기 중인 요청들을 큐에서 관리
 */
import store from "../store";

class TokenRefreshManager {
  constructor() {
    this.isRefreshing = false;
    this.failedQueue = [];
  }

  /**
   * 토큰 갱신 중인지 확인
   */
  isRefreshingToken() {
    return this.isRefreshing;
  }

  /**
   * 실패한 요청을 큐에 추가
   */
  addToFailedQueue(resolve, reject) {
    this.failedQueue.push({ resolve, reject });
  }

  /**
   * 큐에 있는 모든 요청 처리 (성공)
   */
  processQueue(error = null, token = null) {
    this.failedQueue.forEach(({ resolve, reject }) => {
      if (error) {
        reject(error);
      } else {
        resolve(token);
      }
    });

    this.failedQueue = [];
  }

  /**
   * 토큰 갱신 상태 설정
   */
  setRefreshing(isRefreshing) {
    this.isRefreshing = isRefreshing;
  }

  /**
   * 안전한 토큰 갱신 실행
   */
  async safeRefreshToken() {
    if (this.isRefreshing) {
      // 이미 갱신 중이면 Promise를 반환하여 대기
      return new Promise((resolve, reject) => {
        this.addToFailedQueue(resolve, reject);
      });
    }

    this.setRefreshing(true);

    try {
      console.log("🔄 Starting token refresh...");
      await store.dispatch("REFRESH_ACCESS_TOKEN", store);
      console.log("✅ Token refresh completed");

      const newToken = store.state.accessToken;
      this.processQueue(null, newToken);
      return newToken;
    } catch (error) {
      console.error("❌ Token refresh failed:", error);
      this.processQueue(error, null);
      throw error;
    } finally {
      this.setRefreshing(false);
    }
  }
}

// 전역 인스턴스 생성
const tokenRefreshManager = new TokenRefreshManager();

export { tokenRefreshManager };
